import React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { SidebarTrigger } from '../../components/Pleri/components/ChatBox/SidebarTrigger';
import { usePleriStatus } from '../../components/onboarding/apis/pleri-status';
import { useMemory } from '../../api/memory';
import { usePleriRenderOptional } from '../../components/Pleri/context/usePleriRenderOptional';
import { useLayoutStore } from '../../store/layoutStore';
import { PleriStatusGate } from '../../components/Pleri/client/PleriStatusGate';

export const Route = createFileRoute('/trigger/')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { isLoading: isLoadingStatus } = usePleriStatus();
  const { setMiniMode } = useLayoutStore();

  const { isLoading: isLoadingMemory } = useMemory();
  const pleriRenderContext = usePleriRenderOptional();

  if (isLoadingStatus || isLoadingMemory) {
    return null;
  }

  // Navigation logic for trigger clicks
  const handleTriggerClick = () => {
    // If context is available, use it to open
    if (pleriRenderContext) {
      pleriRenderContext.open('mini');
    }

    // // Otherwise, use router navigation (standalone mode)
    // if (!pleriStatus?.isOnboarded) {
    //   return navigate({ to: '/onboarding' });
    // }
    // if (showUserQuestionsChat) {
    //   return navigate({ to: '/settings/about-you/questions' });
    // }
    setMiniMode(true);
    return navigate({
      to: '/c/$conversationId',
      params: { conversationId: 'active' },
    });
  };

  // If renderType is 'navbar' or 'custom', don't show the trigger here
  // (it will be rendered by the parent in their navbar/custom location)
  if (
    pleriRenderContext &&
    (pleriRenderContext.renderType === 'navbar' ||
      pleriRenderContext.renderType === 'custom')
  ) {
    return null;
  }

  // Show trigger for sidebar mode or standalone usage, but only when Pleri is enabled
  return (
    <PleriStatusGate>
      <SidebarTrigger onClick={handleTriggerClick} />
    </PleriStatusGate>
  );
}
